export default "__VITE_ASSET__B5tZc3xc__"